import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { jsx, jsxs } from 'react/jsx-runtime';
import { theme as theme$1, Column, Grid, Row } from '@dls/web';
import styled from 'styled-components';
import SvgHamburgerLine from '../../../../assets/svgs/hamburger-line.svg.js';
import Logo from './Logo.js';
import theme from '../../../../theme/index.js';
import { remCalc } from '../../../../helpers/styles.js';
import '@geit/ui-components';
const SCHeaderMobile = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  ", ";\n"])), theme.media.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
const SCHamburger = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: ", ";\n  cursor: pointer;\n"])), remCalc(16));
const SCIconHamburger = styled(SvgHamburgerLine)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  vertical-align: middle;\n\n  & path {\n    fill: ", ";\n  }\n"])), props => props.theme === "dark" ? theme$1.main.colours.white : theme$1.main.colours.black);
const SCHamburgerColumn = styled(Column)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"])));
const HamburgerMenu = _ref => {
  let {
    onClick,
    theme: theme2
  } = _ref;
  return /* @__PURE__ */jsx(SCHamburger, {
    onClick,
    children: /* @__PURE__ */jsx(SCIconHamburger, {
      width: 22,
      theme: theme2
    })
  });
};
const MobileHeader = _ref2 => {
  let {
    baseUrl,
    logoLink,
    logoAlt,
    logoSrc,
    showHamburger,
    onHamburgerClick,
    theme: theme2
  } = _ref2;
  return /* @__PURE__ */jsx(SCHeaderMobile, {
    id: "mobile",
    children: /* @__PURE__ */jsx(Grid, {
      children: /* @__PURE__ */jsxs(Row, {
        middle: "sm",
        children: [/* @__PURE__ */jsx(SCHamburgerColumn, {
          xs: 4,
          children: showHamburger && /* @__PURE__ */jsx(HamburgerMenu, {
            onClick: onHamburgerClick,
            theme: theme2
          })
        }), /* @__PURE__ */jsx(Column, {
          xs: 4,
          children: /* @__PURE__ */jsx(Logo, {
            baseUrl,
            link: logoLink,
            alt: logoAlt,
            src: logoSrc
          })
        }), /* @__PURE__ */jsx(Column, {
          xs: 4
        })]
      })
    })
  });
};
export { MobileHeader as default };